// extracted by mini-css-extract-plugin
module.exports = {"input":"_1z2UUS"};